import React from "react";
import "../../styles/Contact.css";
import ContactForm from "./contactForm";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: false,
      formSuccess: "",
      formData: {
        email: {
          element: "input",
          value: "",
          config: {
            name: "email_input",
            type: "email",
            placeholder: "Enter Your email"
          },
          validation: {
            required: true,
            email: true
          },
          valid: false,
          validationMessage: ""
        }
      }
    };

    // this.onSendMessage = this.onSendMessage.bind(this);
  }

  render() {
    return (
      <div className="contact">
        <ContactForm />
        <div className="contact-links">
          <p>
            You can send me a message or contact me via e-mail at:{" "}
            <a href="mailto:mohitsngh1997@gmail.com" target="blank">
              <mark>mohitsngh1997@gmail.com</mark>.
            </a>
          </p>
          <p>
            You can also visit my LinkedIn page, download{" "}
            <a
              href="https://drive.google.com/file/d/18DR2PGbyeDU4n1R6fQRjB-1eKm5JH1OY/view?usp=sharing"
              target="blank"
            >
              Resume{" "}
            </a>
            or check out my profiles on GitHub and other social media platforms,
            where you can see more of my work, on the links bellow.
          </p>
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/negimohit/" target="blank">
                <i
                  className="fa fa-linkedin-square fa-3x"
                  aria-hidden="true"
                ></i>
              </a>
            </li>
            <li>
              <a href="https://github.com/negimohit1209" target="blank">
                <i className="fa fa-github fa-3x" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/mohitsinghnegi" target="blank">
                <i
                  className="fa fa-facebook-square fa-3x"
                  aria-hidden="true"
                ></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/negimohit1209/" target="blank">
                <i className="fa fa-instagram fa-3x" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/mohitsngh1997" target="blank">
                <i
                  className="fa fa-twitter-square fa-3x"
                  aria-hidden="true"
                ></i>
              </a>
            </li>
            <li>
              <a
                href="https://stackoverflow.com/users/9610517/mohit-negi"
                target="blank"
              >
                <i
                  className="fa fa-stack-overflow fa-3x"
                  aria-hidden="true"
                ></i>
              </a>
            </li>
            <li>
              <a href="https://medium.com/@mohitsngh1997" target="blank">
                <i className="fa fa-medium fa-3x" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <a href="https://codepen.io/negimohit1209/" target="blank">
                <i className="fa fa-codepen fa-3x" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.js